module.exports = __webpack_public_path__ + "eb9a23979d2dc6bc8c4ac99a04436268.svg";